import React from "react";
import styles from "./InteractiveWalkthroughSec.module.css";
import { Container } from "react-bootstrap";

const InteractiveWalkthroughSec = ({
  subHeading = "INTERACTIVE WALKTHROUGH",
  heading = "SEE HOW A TRU SITE POWER SYSTEM WORKS",
  description = "Scroll through how we build and run a solar and battery site office: the problem with 24/7 generators, how the battery runs the site, how the container is built in our shop, the Power C-Can, sizing, a real scale house result, rent or own, and service.",
  iframeSrc = "/commercial-site-power-story.html",
  padding,
  backgroundImage,
  backgroundGradient,
}) => {
  return (
    <div
      style={{
        backgroundImage: backgroundImage
          ? `url("/images/video_background.jpg")`
          : backgroundGradient && backgroundGradient,
        padding: padding && padding,
      }}
      className={styles.main}
    >
      <Container className={styles.customContainer}>
        {/* Header Section */}
        <div className={styles.headerWrapper}>
          {subHeading && <h3 className="h2_main">{subHeading}</h3>}
          {heading && <h2 className="h1_main">{heading}</h2>}
          {description && <p className={styles.descriptionText}>{description}</p>}
        </div>

        <div className={styles.frameWrapper}>
          <div className={styles.iframeContainer}>
            <iframe
              src={iframeSrc}
              title="Interactive Walkthrough"
              className={styles.iframe}
              loading="lazy"
            />
            <a
              href={iframeSrc}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.fullScreenBtn}
            >
              OPEN FULL SCREEN
            </a>
          </div>
        </div>

        {/* <p className={styles.footerNote}>
          The walkthrough sits in a frame on the page and scrolls inside it. The OPEN FULL SCREEN button opens the same file on its own.
        </p> */}
      </Container>
    </div>
  );
};

export default InteractiveWalkthroughSec;